<template>
  <embedded-crud-table
    :entity="entity"
    :entity-store="entityStore"
    :columns="columns"
    :definition="definition"
    :generate-summary="generateSummary"
    :caption="caption"
    :parent-id-filter-field="parentIdFilterField"
    :open-in-fullscreen="openInFullscreen"
    :required="required"
    :permission-code="permissionCode"
    :create-item-from-form-data="createItemFromFormData"
    :create-form-data-from-item="createFormDataFromItem"
  />
</template>

<script>
import EmbeddedCrudTable from '@/components/crud/EmbeddedCrudTable';
import formMixin from './form-mixin';

export default {
  components: {
    EmbeddedCrudTable
  },
  mixins: [formMixin],
  props: {
    caption: String,
    parentIdFilterField: {
      type: String,
      required: true
    },
    permissionCode: String,
    disabled: {
      default: false,
      type: Boolean
    },
    openInFullscreen: {
      default: false,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      columns: [
        {
          field: 'glAccountNumber',
          label: 'common.glAccountNumber'
        },
        {
          field: 'description'
        },
        {
          field: 'type',
          formatter: this.formatGlAccountType,
          filter: { type: 'none' },
          sortable: false
        }
      ]
    };
  },
  methods: {
    formatGlAccountType(row, column, cellValue) {
      const option =
        cellValue !== null &&
        this.$store.getters['option/loadedOptions']('glAccountType').find(item => item.code === cellValue);
      return option && option.description;
    },
    generateSummary(row) {
      return `${row.glAccountNumber} ${row.description}`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
